// src/components/post_details.jsx
import Post_detail_body from "./post_detail_body.jsx";

export default function Post_detail() {
  return <Post_detail_body />;
}
